import { getSessionStore } from "app/utils/sessionStore";
import ThreadsContainer from "../../PremiumFinanceThreads/ThreadsContainer";
import { useEffect, useState } from "react";

function ThreadsIntRev() {
  const planId = getSessionStore("planInfo")?.planId;
  const [selectedYear, setSelectedYear] = useState<number>(getSessionStore("ircSelectedYear") ?? 1);

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail ?? {};
      if (detail.year !== undefined) {
        setSelectedYear(detail.year);
      }
    };
    window.addEventListener("ircSelectionChanged", handler);
    return () => window.removeEventListener("ircSelectionChanged", handler);
  }, []);

  return (
    <div>
      <ThreadsContainer
        proposalId={planId ?? ""}
        isPlan
        threadType=""
        selectedYear={selectedYear}
      />
    </div>
  );
}
export default ThreadsIntRev;
